<template>
  <div class="contact">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h1>联系我们</h1>
      <p>期待与您的沟通与合作</p>
    </div> -->
    
    <div class="container">
      <h1 class="contact__title">联系我们</h1>
      
      <div class="contact__content">
        <!-- 联系方式展示模块 -->
        <div class="contact__info">
          <h2 class="contact__info-title">联系方式</h2>
          <div class="contact__info-list">
            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.34 11.5 9 10.16 9 8.5C9 6.84 10.34 5.5 12 5.5C13.66 5.5 15 6.84 15 8.5C15 10.16 13.66 11.5 12 11.5Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>公司地址</h3>
                <p>{{ contactInfo.address }}</p>
              </div>
            </div>
            
            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9C16.3 14.9 16.2 14.9 16.1 14.9C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8.2 13.6 7 11L9.2 8.8C9.4 8.6 9.5 8.4 9.5 8.1C9.5 8 9.5 7.9 9.4 7.8C9 6.7 8.8 5.4 8.8 4.2C8.8 3.5 8.2 3 7.5 3H4.5C3.8 3 3.2 3.5 3.2 4.2C3.2 13.1 9.9 20.8 18.8 20.8C19.5 20.8 20 20.2 20 19.5V16.5C20 15.8 19.5 15.5 18.8 15.5H20Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>联系电话</h3>
                <p>{{ contactInfo.phone }}</p>
              </div>
            </div>
            
            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>电子邮箱</h3>
                <p>{{ contactInfo.email }}</p>
              </div>
            </div>
            
            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8C14 6.9 13.1 6 12 6ZM12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15C15 16.66 13.66 18 12 18Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>工作时间</h3>
                <p>{{ contactInfo.workingHours }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 留言表单组件 -->
        <div class="contact__form">
          <h2 class="contact__form-title">留言咨询</h2>
          <form @submit.prevent="submitForm" class="contact__form-content">
            <div class="contact__form-group">
              <label for="name" class="contact__form-label">姓名</label>
              <input type="text" id="name" v-model="formData.name" class="contact__form-input" placeholder="请输入您的姓名" required>
            </div>
            
            <div class="contact__form-group">
              <label for="email" class="contact__form-label">邮箱</label>
              <input type="email" id="email" v-model="formData.email" class="contact__form-input" placeholder="请输入您的邮箱" required>
            </div>
            
            <div class="contact__form-group">
              <label for="phone" class="contact__form-label">电话</label>
              <input type="tel" id="phone" v-model="formData.phone" class="contact__form-input" placeholder="请输入您的电话" required>
            </div>
            
            <div class="contact__form-group">
              <label for="message" class="contact__form-label">留言内容</label>
              <textarea id="message" v-model="formData.message" class="contact__form-textarea" placeholder="请输入您的留言内容" rows="5" required></textarea>
            </div>
            
            <button type="submit" class="contact__form-submit" :disabled="isSubmitting">
              {{ isSubmitting ? '提交中...' : '提交留言' }}
            </button>
          </form>
          
          <!-- 提交成功提示 -->
          <div class="contact__form-success" v-if="submitSuccess">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="#4CAF50"/>
              <path d="M14 24L20 30L34 16" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p>留言提交成功！我们会尽快与您联系。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      // 联系信息 mock 数据
      contactInfo: {
        address: '贵州省遵义市播州区芶江镇贵州苟江经济开发区苟江标准厂房E栋',
        phone: '0851-23212555',
        workingHours: '周一至周五 9:00-18:00'
      },
      // 表单数据
      formData: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      // 提交状态
      isSubmitting: false,
      submitSuccess: false
    }
  },
  methods: {
    // 提交表单
    submitForm() {
      this.isSubmitting = true
      
      // 模拟表单提交
      setTimeout(() => {
        console.log('表单提交数据:', this.formData)
        // 这里是预留的表单提交接口位置
        // 实际项目中可以通过 axios 调用后端接口
        // this.$axios.post('/api/contact', this.formData)
        
        // 重置表单
        this.formData = {
          name: '',
          email: '',
          phone: '',
          message: ''
        }
        
        // 显示成功提示
        this.submitSuccess = true
        this.isSubmitting = false
        
        // 3秒后隐藏成功提示
        setTimeout(() => {
          this.submitSuccess = false
        }, 3000)
      }, 1000)
    }
  }
}
</script>

<style scoped>
.contact {
  padding: 0;
}

.page-header {
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  margin-bottom: 0;
}

.page-header h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.page-header p {
  font-size: 16px;
  color: #666;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.contact__title {
  text-align: center;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 40px;
  color: #333;
}

.contact__content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

/* 联系方式样式 */
.contact__info {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.contact__info-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.contact__info-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact__info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.contact__info-icon {
  color: #007bff;
  margin-top: 2px;
  flex-shrink: 0;
}

.contact__info-text h3 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #555;
}

.contact__info-text p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* 表单样式 */
.contact__form {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.contact__form-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.contact__form-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact__form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contact__form-label {
  font-size: 14px;
  font-weight: 500;
  color: #555;
}

.contact__form-input,
.contact__form-textarea {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.contact__form-input:focus,
.contact__form-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.contact__form-textarea {
  resize: vertical;
  min-height: 120px;
}

.contact__form-submit {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.contact__form-submit:hover {
  background-color: #0069d9;
}

.contact__form-submit:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* 提交成功提示 */
.contact__form-success {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  animation: fadeIn 0.3s ease;
}

.contact__form-success p {
  font-size: 16px;
  color: #333;
  text-align: center;
  margin: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式布局 */
@media (max-width: 768px) {
  .contact__content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .contact__title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  
  .contact__info,
  .contact__form {
    padding: 20px;
  }
  
  .contact__info-title,
  .contact__form-title {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .contact {
    padding: 20px 0;
  }
  
  .contact__title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .contact__info,
  .contact__form {
    padding: 15px;
  }
  
  .contact__info-item {
    gap: 10px;
  }
  
  .contact__form-input,
  .contact__form-textarea {
    padding: 10px;
  }
  
  .contact__form-submit {
    padding: 10px 16px;
  }
}
</style>